import { Injectable } from "@angular/core";
import { JwtPayloadService } from "../services/jwt-payload.service";

@Injectable({
  providedIn: "root",
})
export class CredentiaisService {
  constructor(private jwtPayload: JwtPayloadService) {}

  /**
   * Retorna o nome do usuário logado a partir do JWT.
   * Retorna string vazia se o token não existir.
   *
   * @returns Nome do usuário ou string vazia
   */
  getUser(): string {
    const token = sessionStorage.getItem("x");
    if (!token) return "";
    try {
      const merged = this.jwtPayload.getMergedPayload(token) as { user?: string };
      return merged.user || "";
    } catch {
      return "";
    }
  }

  /**
   * Retorna o payload do JWT com `user` e `roles` resolvidos (incluindo descriptografia de `enc` quando presente).
   *
   * @param token - JWT completo
   * @returns Objeto de claims mesclado
   */
  parseJwt(token: string): Record<string, unknown> {
    return this.jwtPayload.getMergedPayload(token);
  }
}
